<template>
    <layout title="Calculate your ROI: ID digital solutions ROI calculator" :transparent="true" class="overflow-x-hidden">
        <section1 />
        <calculatorSection :errors="errors" :isV1="true"/>
    </layout>
</template>
  
  
  
<script>
const layout = () =>
    import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
const section1 = () =>
    import(
    /* webpackChunkName: "section1" */ "../Components/Layout/RoiCalculator/section1.vue"
    );
const calculatorSection = () =>
    import(
    /* webpackChunkName: "section1" */ "../Components/Layout/RoiCalculator/calculatorSection.vue"
    );
export default {
    components: { layout, section1, calculatorSection },
    props: {
        errors: Object,
    },
};
</script>
  